var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',_vm._l((_vm.dataModels),function(commentModel,index){return _c('Comment',{key:index,attrs:{"data":_vm.data,"element":_vm.element,"model":_vm.dataModels,"index":index,"rules":_vm.rules,"remote":_vm.remote,"disabled":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }